export default [
  {
    path: '/arena_mission',
    name: 'MissionView',
    component: () =>
      import(/* webpackChunkName: "arena" */ '@/views/Arena/MissionView.vue'),
    meta: { title: 'Arena Mission', group: 'arena' },
  },
  {
    path: '/arena_tokens',
    name: 'TokensView',
    component: () =>
      import(/* webpackChunkName: "arena" */ '@/views/Arena/TokensView.vue'),
    meta: { title: 'Arena Tokens', group: 'arena' },
  },
  {
    path: '/arena_tokens_history',
    name: 'TokensHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "arena" */ '@/views/Arena/TokensHistoryView.vue'
      ),
    meta: { title: 'Arena Tokens History', group: 'arena' },
  },
]
